import { CalendarPlus, Gift, PackagePlus, ShoppingBag } from "lucide-react";
import { useNavigate } from "react-router-dom";
import QuickActionCard from "../components/QuickActionCard";

const actions = [
  { id: "order", title: "Create Order", description: "Enter a phone or email order", icon: ShoppingBag, path: "/admin/orders" },
  { id: "product", title: "Add Menu Item", description: "Create a new product", icon: PackagePlus, path: "/admin/menu" },
  { id: "special", title: "Monthly Special", description: "Create or update a special", icon: Gift, path: "/admin/specials" },
  { id: "blackout", title: "Block a Date", description: "Close an unavailable delivery date", icon: CalendarPlus, path: "/admin/deliveries" },
];

function QuickActions() {
  const navigate = useNavigate();
  return <div className="quick-actions">{actions.map((action) => <QuickActionCard key={action.id} {...action} onClick={() => navigate(action.path)} />)}</div>;
}

export default QuickActions;
